import React, { useEffect, useState } from 'react';

function FoodGeneralSettings({ token, selectedProperty }) {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [mode, setMode] = useState('MANDATORY');

  const chainId = String(selectedProperty?.chain_id || '').trim();
  const propertyId = String(selectedProperty?.id || '').trim();
  const headers = (extra = {}) => ({
    Authorization: `Bearer ${token}`,
    'x-chain-id': chainId,
    'x-property-id': propertyId,
    ...extra
  });

  const parseResponse = async (res) => {
    const raw = await res.text();
    try {
      const json = raw ? JSON.parse(raw) : {};
      return { data: json, message: json?.error || '' };
    } catch {
      return { data: {}, message: raw || '' };
    }
  };

  const loadSettings = async () => {
    if (!chainId || !propertyId) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/v1/food/settings/general', { headers: headers() });
      const { data, message: msg } = await parseResponse(res);
      if (!res.ok) return setError(msg || 'Failed to load settings');
      setMode(String(data?.pr_approval_mode || 'MANDATORY').toUpperCase());
    } catch {
      setError('Network error while loading settings');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!chainId || !propertyId) {
      setError('Select a property first from Hotel Config');
      return;
    }
    setError('');
    loadSettings();
  }, [token, chainId, propertyId]);

  const save = async () => {
    if (!chainId || !propertyId) return setError('Select a property first from Hotel Config');
    setSaving(true);
    setError('');
    setMessage('');
    try {
      const res = await fetch('/api/v1/food/settings/general', {
        method: 'PUT',
        headers: headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ pr_approval_mode: mode })
      });
      const { message: msg } = await parseResponse(res);
      if (!res.ok) return setError(msg || 'Save failed');
      setMessage('General settings updated');
    } catch {
      setError('Network error while saving');
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = { padding: '0.6rem', border: '1px solid #dcdde1', borderRadius: '6px', minWidth: '260px' };

  return (
    <div className="page-shell">
      <h2 style={{ color: '#2f855a' }}>Food Management - General Settings</h2>
      {error && <div className="error-banner">{error}</div>}
      {message && <div className="success-banner">{message}</div>}

      <div className="filter-bar">
        <h3>Purchase Requisition Approval Mode</h3>
        <p style={{ marginTop: 0, color: '#4a5568' }}>
          `MANDATORY` means submit goes to Pending Approval. `OPTIONAL` means submit auto-approves.
        </p>
        <div style={{ display: 'flex', gap: '0.7rem', alignItems: 'center' }}>
          <select value={mode} onChange={(e) => setMode(e.target.value)} style={inputStyle} disabled={loading || saving}>
            <option value="MANDATORY">MANDATORY</option>
            <option value="OPTIONAL">OPTIONAL</option>
          </select>
          <button onClick={save} className="btn-success" style={{ padding: '0.55rem 1rem', border: 'none', borderRadius: '6px', cursor: 'pointer' }} disabled={loading || saving}>
            {saving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FoodGeneralSettings;
